import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import FeaturedArticles from './components/FeaturedArticles';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';
import SchemaOrg from '@/components/base/SchemaOrg';

export default function Home() {
  return (
    <>
      <SchemaOrg
        type="WebSite"
        data={{
          name: '彩金攻略',
          url: typeof window !== 'undefined' ? window.location.origin : '',
          description: '注册送彩金优惠资讯平台，提供最新注册送彩金活动信息、领取攻略与提款指南',
          inLanguage: 'zh-CN',
        }}
      />
      <SchemaOrg
        type="Organization"
        data={{
          name: '彩金攻略',
          url: typeof window !== 'undefined' ? window.location.origin : '',
          description: '致力于为新用户提供最新、最全面的注册送彩金优惠资讯',
        }}
      />
      <HeroSection />
      <CategorySection />
      <FeaturedArticles />
      <FAQSection />
      <SchemaOrg
        type="FAQPage"
        data={{
          mainEntity: [
            { '@type': 'Question', name: '注册送彩金是真的吗？需要付费吗？', acceptedAnswer: { '@type': 'Answer', text: '正规平台的注册送彩金活动是真实有效的，完全免费，无需支付任何费用。' } },
            { '@type': 'Question', name: '彩金可以直接提现吗？', acceptedAnswer: { '@type': 'Answer', text: '需要满足一定流水（投注倍数）要求后才能提现。' } },
            { '@type': 'Question', name: '注册后多久能收到彩金？', acceptedAnswer: { '@type': 'Answer', text: '大部分平台的注册彩金即时到账，部分可能需要人工审核，通常不超过24小时。' } },
            { '@type': 'Question', name: '一个身份证能注册多个平台吗？', acceptedAnswer: { '@type': 'Answer', text: '可以，不同平台之间独立运营。但同一平台严禁注册多个账户。' } },
            { '@type': 'Question', name: '彩金有使用期限吗？', acceptedAnswer: { '@type': 'Answer', text: '大多数平台注册彩金有效期为7-30天，逾期未使用将失效。' } },
          ],
        }}
      />
      <CTASection />
    </>
  );
}